<template>
  <ais-state-results v-bind="$attrs">
    <template v-slot="{ state }">
      <div v-if="hasRefinments(state)">
        <span>
          {{ getRefinements(state).length }} {{ 'selected' | t }}
        </span>
      </div>
      <div v-else></div>
    </template>
  </ais-state-results>
</template>

<script>
import t from '../main/i18n';

export default {
  props: {
    attribute: {type: String, required: true}
  },
  methods: {
    hasRefinments(state) {
      const refinements = this.getRefinements(state);
      return refinements && refinements.length > 0;
    },
    getRefinements(state) {
      return state.facetsRefinements[this.attribute];
    }
  },
  filters: {
    t
  }
};
</script>
